/// <amd-module name="Pipeline/Analytics/PipelineOutcome/Common/MockData" />
import { ITrendChartData, ITrendChartReportConfiguration } from "Analytics/Shared/TrendChart/Common/Types";
import {
    getMockReportData,
    getMockStageData,
    getMoreMockStageData,
    stageFailureDistribution,
    totalCount,
    totalFailedCount
} from "Pipeline/Analytics/Common/MockReportData";
import { IPipelineOutcomeData, IPipelineOutcomePassRateData } from "Pipeline/Analytics/Common/Types";
import { IDailyTaskFailureData, IFailingTaskData, IPipelineOutcomeTaskFailureData } from "Pipeline/Analytics/PipelineOutcome/Common/Types";

export function getMockPipelineOutcomeData(confValues: ITrendChartReportConfiguration, stageAware = true): IPipelineOutcomeData {
    const chartData: ITrendChartData = {
        primaryChartData: stageAware ? {} : { [""]: [] },
        secondaryChartData: [],
        confValues: confValues,
        isCachedData: false
    };
    const pipelineOutcomePassRateData: IPipelineOutcomePassRateData = getMockPipelineOutcomePassRateData();
    const stages = getMockStageData();
    const reportData = getMockReportData();
    reportData.forEach((data: any) => {
        if (stageAware) {
            for (let index = 0; index < stages.length; index++) {
                if (!chartData.primaryChartData[stages[index].name]) {
                    chartData.primaryChartData[stages[index].name] = [];
                }
                chartData.primaryChartData[stages[index].name].push({
                    date: data.date as string,
                    aggrValue: data.failedCount * stageFailureDistribution[index]
                });
            }
            chartData.secondaryChartData!.push({ date: data.date as string, aggrValue: data.passPercentage as number });
        } else {
            chartData.primaryChartData[""].push({ date: data.date as string, aggrValue: data.failedCount });
            chartData.secondaryChartData!.push({ date: data.date as string, aggrValue: data.passPercentage as number });
        }
    });
    const pipelineOutcomeData: IPipelineOutcomeData = { trendChartData: chartData, pipelineOutcomePassRateData: pipelineOutcomePassRateData };
    return pipelineOutcomeData;
}

export function getMockPipelineOutcomePassRateData(getMoreStageData = false): IPipelineOutcomePassRateData {
    const cardData: IPipelineOutcomePassRateData = {
        passPercentage: Math.round(((totalCount - totalFailedCount) / totalCount) * 100),
        failedCount: totalFailedCount,
        totalCount: totalCount,
        passedCount: totalCount - totalFailedCount,
        failurePerStage: getMoreStageData ? [...getMoreMockStageData()] : [...getMockStageData()]
    };
    return cardData;
}

export function getMockTaskTrendData(): IPipelineOutcomeTaskFailureData {
    const mockData = getMockReportData();
    const taskFailureData: { [key: string]: IFailingTaskData } = {};
    const trendChartData = mockData.map((mockDatum: any) => {
        return {
            date: mockDatum.date,
            taskFailures: mockDatum.taskFailures
        } as IDailyTaskFailureData;
    });
    trendChartData.forEach(d => {
        d.taskFailures.forEach(t => {
            if (!taskFailureData[t.taskName]) {
                taskFailureData[t.taskName] = {
                    taskName: t.taskName,
                    failedCount: 0
                };
            }
            taskFailureData[t.taskName].failedCount += t.failedCount;
        });
    });
    const pipelineOutcomeTaskFailureData = {
        trendChartData: trendChartData,
        topFailingTasks: {
            failingTasksData: Object.keys(taskFailureData)
                .map(taskData => {
                    return taskFailureData[taskData];
                })
                .sort((a, b) => b.failedCount - a.failedCount),
            failedCount: totalFailedCount
        }
    };
    return pipelineOutcomeTaskFailureData;
}

export function getMockEmptyStageData(confValues: ITrendChartReportConfiguration): IPipelineOutcomeData {
    const chartData: ITrendChartData = {
        primaryChartData: {},
        secondaryChartData: [],
        confValues: confValues,
        isCachedData: false
    };

    const pipelineOutcomePassRateData: IPipelineOutcomePassRateData = {
        passPercentage: 0,
        failedCount: 0,
        totalCount: 0,
        passedCount: 0,
        failurePerStage: []
    } as IPipelineOutcomePassRateData;

    const pipelineOutcomeData: IPipelineOutcomeData = { trendChartData: chartData, pipelineOutcomePassRateData: pipelineOutcomePassRateData };
    return pipelineOutcomeData;
}
